import { Typography } from "@pankod/refine-antd";
import { ShowUserCard } from "components/profile/showUserCard";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { IBaseProps } from "interfaces";
import { displayRelativeDate } from "./displayRelativeDate";
dayjs.extend(relativeTime);

export const CreatedBy: React.FC<IBaseProps> = (propObj: IBaseProps) => {
    if (propObj) {
        const greyStyle = { color: "GrayText" };
        return (
            <>
                <Typography.Text style={greyStyle}>Created by </Typography.Text>
                <ShowUserCard id={propObj.createdBy}></ShowUserCard>
                {displayRelativeDate(propObj?.createdAt)}
            </>
        );
    }
    return <></>;
};